import gljyForm from "./base-form/form/gljy-form";
import gljyFormItem from "./base-form/form/gljy-form-item";
import gljyInput from "./base-form/input/gljy-input";
import gljyInputNumber from "./base-form/input/gljy-input-number";
import gljyButton from "./base-form/button/gljy-button";
import gljyCheckbox from "./base-form/checkbox/gljy-checkbox";
import gljyRichText from "./rich-text/gljy-rich-text";
import gljySpan from "./base-form/span/gljy-span";

export default [
    gljyForm,
    gljyFormItem,
    gljyInput,
    gljyInputNumber,
    gljyButton,
    gljyCheckbox,
    gljyRichText,
    gljySpan
]